module.exports = __webpack_public_path__ + "img/tabbar-reward.cb749ada.png";